export { PwaUpdateService } from './lib/pwa-update.service';
export { providePwaUpdate } from './lib/pwa-update.provider';
